export default __webpack_public_path__ + "static/mightyc-teaser2-tabletx2-98f615efe51fe596843b1712837f1d45.png";